/**
 * Inactivity deadline. Activity pushes the deadline out, but only while it has not passed:
 * a background tab whose timer was throttled must still lock when the user comes back.
 */
export class IdleDeadline {
  private readonly limitMs: number;
  private deadline: number;

  public constructor(limitMs: number, now: number) {
    this.limitMs = limitMs;
    this.deadline = now + limitMs;
  }

  /** Records activity. Returns false when the deadline had already passed (caller must lock). */
  public touch(now: number): boolean {
    if (this.expired(now)) {
      return false;
    }
    this.deadline = now + this.limitMs;
    return true;
  }

  public expired(now: number): boolean {
    return now >= this.deadline;
  }

  public remaining(now: number): number {
    return Math.max(0, this.deadline - now);
  }
}

/** m:ss for countdowns. */
export function formatCountdown(ms: number): string {
  const total = Math.ceil(Math.max(0, ms) / 1000);
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}
